import { nostoPlacements } from "@/redux/actions/nostoAction";
import store from "@/redux/store";
import { setCurrentPageTypeCookie } from "@/helpers/generalHelper";
import { getCurrentPageTypeCookie } from "@/helpers/generalHelper";
import { reportError } from "@/helpers/errorHelper";
import { setCookie } from "cookies-next";
import { setNostoLoad } from "@/redux/actions/pwaAction";

export const viewFrontPage = async () => {
  setCurrentPageTypeCookie("home");
  if (typeof nostojs != "undefined") {
    nostojs((api) => {
      var nostoPlacements = api.placements.getPlacements();
      try {
        api
          ?.defaultSession()
          ?.setResponseMode("HTML")
          ?.viewFrontPage()
          ?.setPlacements(nostoPlacements)
          ?.load()
          .then((response) => {
            api.placements.injectCampaigns(response.recommendations);
            setNostoPlacements(response);
          });
      } catch (e) {
        reportError("Nosto API call error - viewFrontPage");
        reportError(e.stack)
        // reportError(e)
      }
    });
  }
};
export const viewOther = async () => {
  setCurrentPageTypeCookie("other");
  if (typeof nostojs != "undefined") {
    nostojs((api) => {
      var nostoPlacements = api.placements.getPlacements();
      try {
        api
          ?.defaultSession()
          ?.setResponseMode("HTML")
          ?.viewOther()
          ?.setPlacements(nostoPlacements)
          ?.load()
          .then((response) => {
            api.placements.injectCampaigns(response.recommendations);
            setNostoPlacements(response);
          });
      }
      catch (e) {
        reportError("Nosto API call error - viewOther");
        reportError(e.stack)
      }
    });
  }
};
export const viewRecommendation = async () => {
  setCurrentPageTypeCookie("recommendation");
  if (typeof nostojs != "undefined") {
    nostojs((api) => {
      var nostoPlacements = api.placements.getPlacements();
      nostoPlacements.push("checkout-recommendation-slot-1-nosto");
      nostoPlacements.push("checkout-recommendation-slot-2-nosto");
      try {
        api
          ?.defaultSession()
          ?.setResponseMode("HTML")
          ?.viewOther()
          ?.setPlacements(nostoPlacements)
          ?.load()
          .then((response) => {
            api.placements.injectCampaigns(response.recommendations);
            setNostoPlacements(response);
            if (response.recommendations) {
              setCookie("fetched_recommendation", true);
            }
          });
      } catch (e) {
        reportError("Nosto API call error - viewRecommendation");
        reportError(e.stack)
      }
    });
  }
};
export const viewProduct = (dataInput) => {
  if (dataInput.productId) {
    const shopifyProductId = dataInput.productId.replace("gid://shopify/Product/", "");
    setCurrentPageTypeCookie("product", shopifyProductId);
    if (typeof nostojs != "undefined") {
      nostojs((api) => {
        var nostoPlacements = api.placements.getPlacements();
        try {
          api
            ?.defaultSession()
            ?.setResponseMode("HTML")
            ?.viewProduct(shopifyProductId)
            ?.setPlacements(nostoPlacements)
            ?.load()
            .then((response) => {
              api.placements.injectCampaigns(response.recommendations);
              setNostoPlacements(response);
            });
        } catch (e) {
          reportError("Nosto API call error - viewProduct");
          reportError(e.stack)
        }
      });
    }
  }
};
export const viewCollection = async (dataInput) => {
  if (dataInput.collectionPath) {
    setCurrentPageTypeCookie("collection", dataInput.collectionPath);
    if (typeof nostojs != "undefined") {
      nostojs((api) => {
        var nostoPlacements = api.placements.getPlacements();
        nostoPlacements.push("quick-links-plp");
        try {
          api
            ?.defaultSession()
            ?.setResponseMode("HTML")
            ?.viewCategory(dataInput.collectionPath)
            ?.setPlacements(nostoPlacements)
            ?.load()
            .then((response) => {
              api.placements.injectCampaigns(response.recommendations);
              setNostoPlacements(response);
            });
        } catch (e) {
          reportError("Nosto API call error - viewCollection");
          reportError(e.stack)
        }
      });
    }
  }
};
export const search = async (dataInput) => {
  if (typeof nostojs != "undefined" && dataInput.searchedTerm) {
    nostojs((api) => {
      var nostoPlacements = api.placements.getPlacements();
      try {
        api
          ?.defaultSession()
          ?.viewSearch(dataInput.searchedTerm)
          ?.setPlacements(nostoPlacements)
          ?.load()
          .then((data) => { });
      } catch (e) {
        reportError("Nosto API call error - search");
        reportError(e.stack)
      }
    });
  }
};
export const viewNotFound = async () => {
  setCurrentPageTypeCookie("404");
  if (typeof nostojs != "undefined") {
    nostojs((api) => {
      var nostoPlacements = api.placements.getPlacements();
      try {
        api
          ?.defaultSession()
          ?.setResponseMode("HTML")
          ?.viewNotFound()
          ?.setPlacements(nostoPlacements)
          ?.load()
          .then((response) => {
            api.placements.injectCampaigns(response.recommendations);
            setNostoPlacements(response);
          });
      } catch (e) {
        reportError("Nosto API call error - viewNotFound");
        reportError(e.stack)
      }
    });
  }
};
export const viewCart = async (pageType) => {
  if (typeof pageType != "undefined" && pageType == "cartpage") {
    setCurrentPageTypeCookie("cart");
  }
  if (typeof nostojs != "undefined") {
    nostojs((api) => {
      var nostoPlacements = api.placements.getPlacements();
      nostoPlacements.push("cart-related")
      try {
        api
          ?.defaultSession()
          ?.viewCart()
          ?.setPlacements(nostoPlacements)
          ?.load()
          ?.loadRecommendations()
          .then((data) => { });
      } catch (e) {
        reportError("Nosto API call error - viewCart");
        reportError(e.stack)
      }
    });
  }
};
export const setCart = async (data) => {
  if (typeof nostojs != "undefined") {
    try {
      let cartData = await formatCartData(data);
      nostojs((api) => {
        var nostoPlacements = api.placements.getPlacements();
        try {
          api
            ?.defaultSession()
            ?.setCart({
              items: cartData,
            })
            ?.viewCart()
            ?.setPlacements(nostoPlacements)
            ?.update();
        } catch (e) {
          reportError("Nosto API call error - setCart");
          reportError(e.stack)
        }
      });
    } catch (error) {
      reportError("Error in Nosto setCart function");
      reportError(error.stack);
    }
  }
};

export const formatCartData = async (data) => {
  if (typeof data != "undefined" && data) {
    var cartData = [];
    await data.lines.edges.map((item) => {
      let eachItem = {};
      eachItem.name = item.node.merchandise.title;
      eachItem.price_currency_code = item.node.merchandise.priceV2.currencyCode;
      eachItem.product_id = item.node?.merchandise?.product.id.replace("gid://shopify/Product/", "");
      eachItem.quantity = item.node.quantity;
      eachItem.sku_id = item.node?.merchandise?.sku;
      eachItem.unit_price = item.node?.merchandise?.priceV2.amount;

      cartData.push(eachItem);
    });
    return cartData;
  }
};

export const setCustomer = async (data) => {
  if (typeof nostojs != "undefined" && data?.customer) {
    const customerData = {
      customer_reference: data.customer.id,
      email: data.customer.email,
      first_name: data.customer.firstName,
      last_name: data.customer.lastName,
      newsletter: data.customer.acceptsMarketing,
    };
    const pageData = getCurrentPageTypeCookie();
    if (typeof pageData.type != "undefined") {
      switch (pageData.type) {
        case "product":
          if (typeof pageData.data != "undefined") {
            nostojs((api) => {
              var nostoPlacements = api.placements.getPlacements();
              // try {
                api
                  ?.defaultSession()
                  ?.setCustomer(customerData)
                  ?.viewProduct(pageData.data)
                  ?.setPlacements(nostoPlacements)
                  ?.update();
              // } catch (e) {
              //   reportError("Nosto API call error");
              //   reportError(e)
              // }
            });
          }
          break;
        case "collection":
          if (typeof pageData.data != "undefined") {
            nostojs((api) => {
              var nostoPlacements = api.placements.getPlacements();
              // try {
                api
                  .defaultSession()
                  .setCustomer(customerData)
                  .viewCategory(pageData.data)
                  .setPlacements(nostoPlacements)
                  .update();
              // } catch (e) {
              //   reportError("Nosto API call error");
              //   reportError(e)
              // }
            });
          }
          break;
        case "home":
          nostojs((api) => {
            var nostoPlacements = api.placements.getPlacements();
            // try {
              api
                ?.defaultSession()
                ?.setCustomer(customerData)
                ?.viewFrontPage()
                ?.setPlacements(nostoPlacements)
                ?.update();
            // }
            // catch (e) {
            //   reportError("Nosto API call error");
            //   reportError(e)
            // }
          });
          break;
        case "cart":
          nostojs((api) => {
            var nostoPlacements = api.placements.getPlacements();
            // try {
            api
              ?.defaultSession()
              ?.setCustomer(customerData)
              ?.viewCart()
              ?.setPlacements(nostoPlacements)
              ?.update();
            // } catch (e) {
            //   reportError("Nosto API call error");
            //   reportError(e)
            // }
          });
          break;
        case "404":
          nostojs((api) => {
            var nostoPlacements = api.placements.getPlacements();
            // try {
            api
              ?.defaultSession()
              ?.setCustomer(customerData)
              ?.viewNotFound()
              ?.setPlacements(nostoPlacements)
              ?.update();
            // } catch (e) {
            //   reportError("Nosto API call error");
            //   reportError(e)
            // }
          });
        default:
          nostojs((api) => {
            var nostoPlacements = api.placements.getPlacements();
            // try {
            api
              ?.defaultSession()
              ?.setCustomer(customerData)
              ?.viewOther()
              ?.setPlacements(nostoPlacements)
              ?.update();
            // } catch (e) {
            //   reportError("Nosto API call error");
            //   reportError(e)
            // }
          });
      }
    }
  }
};

export const setNostoPlacements = async (nostoResponse) => {
  const nostoPlacementsHTML = store.getState()?.nosto?.nostoPlacements;
  let nostoPlacementsHTMLUpdated = [...nostoPlacementsHTML];
  if (nostoResponse?.recommendations) {
    const nostoRecommendations = nostoResponse.recommendations;
    Object.keys(nostoRecommendations).map((key) => {
      if (typeof nostoPlacementsHTMLUpdated[key] === "undefined") {
        nostoPlacementsHTMLUpdated[key] = nostoRecommendations[key];
      }
    });
  }
  if (nostoPlacementsHTMLUpdated)
    store.dispatch(nostoPlacements(nostoPlacementsHTMLUpdated));
};

export const viewOOSRecommodation = async (productId, skuId) => {
  const shopifyProductId = productId?.replace("gid://shopify/Product/", "");
  const shopifySkuId = skuId?.replace("gid://shopify/ProductVariant/", "");
  if (typeof nostojs != 'undefined') {
    nostojs(api => {
      try {
        api?.defaultSession()
          ?.setResponseMode('HTML')
          ?.viewProductSku(`${shopifyProductId}`, `${shopifySkuId}`)
          ?.setPlacements(['nosto-oos'])
          ?.load()
          .then(response => {
            api.placements.injectCampaigns(response.recommendations)
          })
      }
      catch (e) {
        reportError("Nosto API call error - viewOOSRecommodation");
        reportError(e.stack)
      }
    });
  }
}

/**
 * Helper to load and inject Nosto cart recommendations.
 * @param {object} api - The Nosto API object.
 */
export const loadAndInjectCartRecommendations = (api) => {
  api
    .defaultSession()
    .setResponseMode('HTML')
    .viewCart()
    .setPlacements(api.placements.getPlacements())
    .load()
    .then(response => {
      api.placements.injectCampaigns(response.recommendations);
    });
};